var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"btn",class:{ earthquakeButton: _vm.earthquake },attrs:{"icon":"el-icon-right"},on:{"click":function($event){return _vm.$el.blur()}}},'button',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_c('span',[_vm._t("default",function(){return [_vm._v("Hello")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }